/** @jsxImportSource @emotion/react */
import React, { useEffect, useRef, useState } from "react";
import { stySoundWrapper } from "./styles";

interface Props {
  isOpened?: boolean;
}
const Sound = ({ isOpened = false }: Props) => {
  const bgSound = require("./yellow.mp3");
  const audioRef = useRef<HTMLAudioElement>(null);
  const [playing, setPlaying] = useState(false);

  const firstPlay = useRef(false);

  const playAudio = () => {
    setPlaying(!playing);
  };

  useEffect(() => {
    if (audioRef.current && firstPlay.current) {
      if (playing) {
        audioRef.current.play();
      } else audioRef.current.pause();
    }
  }, [playing]);

  useEffect(() => {
    if (isOpened)
      if (audioRef.current && !firstPlay.current) {
        firstPlay.current = true;
        audioRef.current.play();
        setPlaying(true);
      }
  }, [isOpened, playing]);

  return (
    <div css={stySoundWrapper} onClick={playAudio}>
      <audio ref={audioRef} src={bgSound} hidden loop />
      <div className="icon" />
      {!playing && <div className="off">\</div>}
    </div>
  );
};

export default Sound;
